import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=20e5fb90&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=20e5fb90&prod&scoped=true&lang=css"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=20e5fb90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Viberary/repos/viberary-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5fb90",
  null
  
)

export default component.exports